(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('gestioneAttiApp')
        .constant('VERSION', "6.2.12")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
